import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Workflow_Overview extends PureComponent {
  render() {
    return (
      <div className="row" id="workflow_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Workflow Overview</h2>
              <p>
                Workflows allow you to add automation in your application. There
                are two types of workflows. Frontend workflows called
                Application events and backend called workflow evens.{" "}
              </p>

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Workflow_Overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/Workflow_Overview.js